// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2K1SP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2sll2","obliqueLine":"membershipbadge_obliqueLine__1-XEW"};